import { useState } from 'react';
import { PartnerDialog } from '~/partials/PartnerDialog';

interface PartnerProps {
    icon: string;
    name: string;
    infoType: string;
}

function Partner(props: PartnerProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <div
                className="flex flex-col items-center w-40 rounded-xl transition-transform duration-500 hover:scale-105 cursor-pointer bg-background-darker"
                onClick={() => setIsOpen(true)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setIsOpen(true);
                    }
                }}
            >
                <img
                    src={props.icon}
                    alt={props.name}
                    className="mt-8 rounded-full w-10 h-10 md:w-24 md:h-24"
                />
                <h3 className="text-lg md:text-2xl mt-2 font-bold text-center">
                    {props.infoType}
                </h3>
                <p className="text-sm md:text-base p-3 mt-1 text-center text-secondary-light">
                    {props.name}
                </p>
            </div>
            <PartnerDialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                infoType={props.infoType}
            />
        </>
    );
}

export default Partner;
